import {
  isGenieTerritorial, isGerman, isHeg, isIgis, isPt, isTicOrComem, isTinOrEcg,
  journeeAccueilTocFilter, verificationNiveauMathTocFilter
} from "./utils";
import student from "../Student";

const seesAhesMenu = ({ ahesRequired, ahesFin, visaRequired, visaAcquired }) =>
  ahesRequired && !(!ahesFin && visaRequired && !visaAcquired)

const isHegAndPt = (student) => isHeg(student) && isPt(student)

const cantSeeVerificationNiveauxLangues = (student) => isGenieTerritorial(student) || isIgis(student)

const disabled = (student) => !(student.passwordHasBeenModified && student.eduIDIsLinked && student.entraMfa && student.mfaConfigured)

const seeProfilLingEN = (student) => !cantSeeVerificationNiveauxLangues(student) && (isHeg(student) || isTicOrComem(student) || (isTinOrEcg(student) && student.languages === 'Anglais'));
const seeProfilLingDE = (student) => !cantSeeVerificationNiveauxLangues(student) && (isHeg(student) || (isTinOrEcg(student) && student.languages === 'Allemand'));

export function getSommaireData(student) {
  return {
    'A effectuer de suite': {
      '/comptes-acces': {
        title: "Comptes d'accès",
        subtitle: "",
        disabled: false
      },
      ...(seesAhesMenu(student) && {
        '/financement-de-vos-etudes': {
          title: 'Financement de vos études',
          inprogresssubtitle: "Attente de validation du secrétariat",
          disabled: disabled(student)
        }
      }),
      ...(!cantSeeVerificationNiveauxLangues(student) && {
        '/verification-niveaux-langues': {
          title: "Vérification des niveaux de langues",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
      ...(seeProfilLingEN(student) && {
        '/profil-linguistique-en': {
          link: `https://lingo-log.heig-vd.ch/en`,
          title: "Profil Linguistique Anglais",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
      ...(seeProfilLingDE(student) && {
        '/profil-linguistique-de': {
          link: `https://lingo-log.heig-vd.ch/de`,
          title: "Profil Linguistique Allemand",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
      ...(verificationNiveauMathTocFilter(student) && {
        '/evaluation-niveau-math': {
          title: "Auto-évaluation en math",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
      '/code-de-savoir-vivre': {
        title: "Code de savoir-vivre",
        subtitle: "",
        disabled: disabled(student)
      },
      '/taxe-annuelle-etudes': {
        title: "Taxe annuelle d'études",
        subtitle: "",
        disabled: disabled(student)
      },
      '/assurance-maladie-et-accident': {
        title: "Assurance maladie et accident",
        subtitle: "",
        disabled: disabled(student)
      },
      ...(isHegAndPt(student) && {
        '/cours-marketing': {
          title: "Cours de marketing en français ou en anglais",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
    },
    'Preparation': {
      '/preparation-a-l-immatriculation': {
        title: "Votre immatriculation",
        subtitle: "",
        inprogresssubtitle: "(en cours de traitement par la HEIG-VD)",
        disabled: disabled(student)
      },
      '/demande-equivalence': {
        title: "Demande d'équivalence",
        subtitle: "",
        disabled: disabled(student)
      },
      '/ordinateur-portable': {
        title: "Préparation de votre ordinateur portable",
        subtitle: "",
        disabled: disabled(student)
      },
      // ...(coursPreparatoiresTocFilter(student) && {'/cours-preparatoires': {
      //   title: "Inscription aux cours préparatoires",
      //   subtitle: "",
      //   disabled: disabled(student)
      // }}),
      // ...(inscriptionUnitesPreparatoiresTocFilter(student) && {'/inscription-unites-preparatoires': {
      //   title: "Inscription aux unités préparatoires",
      //   subtitle: "",
      //   disabled: disabled(student)
      // }}),
    },
    "Rentrée académique": {
      ...(journeeAccueilTocFilter(student) && {
        '/journee-d-accueil': {
          title: "Journée d’accueil - Présence obligatoire",
          subtitle: "",
          disabled: disabled(student)
        }
      }),
      '/journee-d-accueil': {
        title: "Journée d'accueil",
        subtitle: "",
        disabled: disabled(student)
      },
      // '/rentree-et-calendrier-academique': {
      //   title: "Rentrée et calendrier académique",
      //   subtitle: "",
      //   disabled: disabled(student)
      // },
      // '/attestation-d-etudes': {
      //   title: "Attestation d'études",
      //   subtitle: "",
      //   disabled: disabled(student)
      // },
    },
    // 'Informations importantes': {
    //   '/votre-carte-etudiant-e': {
    //     title: "Votre carte d'étudiant-e",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   '/guide-de-l-etudiant-e': {
    //     title: "Guide de l'étudiant-e",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   ...(horaireDesCoursTocFilter(student) && {'/horaire-des-cours': "Horaire des cours"}),
    //   '/problemes-sante-specifiques': {
    //     title: "Problème de santé spécifiques",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   '/situation-de-handicap-ou-maladie': {
    //     title: "Situation de handicap ou maladie",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   '/studios-appartements-chambres': {
    //     title: "Studios / Appartements / Chambres",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   '/mobilite': {
    //     title: "Mobilité - Venir à la HEIG-VD",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    //   '/renonciation': {
    //     title: "Renonciation",
    //     subtitle: "",
    //     disabled: disabled(student)
    //   },
    // }
  }
}